import API from "../index";
import {API_GET_SEARCH_HISTORY_TREATMENT_DETAIL} from "../../constants/api";

async function getTreatmentHistoryDetail(workflowId, treatmentId, params) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
    };
    const data = { ...params };
    const response = await API.get(
      API_GET_SEARCH_HISTORY_TREATMENT_DETAIL(workflowId, treatmentId),
      { params: data },
      { headers }
    );
    const responseData = response.data;
    if (responseData.success === true) {
      return responseData.data;
    }
    return Promise.reject("Can not get treatment details");
  } catch (e) {
    throw e.response;
  }
}

export { getTreatmentHistoryDetail };